import { alpha } from "@mui/material";
import { validateHTMLColorRgb, validateHTMLColorHex } from "validate-color";
/**
 * to convert hexToRgb and rgbToHex use:
 * import { hexToRgb, rgbToHex } from "@mui/material";
 */
const isColorHexOrRgb = (colorString) => {
    return validateHTMLColorRgb(colorString) || validateHTMLColorHex(colorString);
};
/**
 * Function will take an rgb or hex color and apply MUI alpha,
 * which converts it to rgba
 * @param colorString either a rgb or hex color string
 * @param opacity number from 0 (fully transparent) to 1 (fully opaque), decimals included
 * @returns the rgb faded to the level of opacity
 */
export const convertRgbOrHexToRgba = (colorString, opacity) => {
    // If colorString is hex or RGB, apply alpha to fade it
    if (isColorHexOrRgb(colorString)) {
        return alpha(colorString, opacity);
        // If colorString is not hex or RGB but still a valid color, return it
    }
    else {
        return colorString;
    }
};
